module.exports = __webpack_public_path__ + "static/temitope-e5f056e3ee47c4e4e95a9e0c569eee56.png";